<template>
  <div class="content" v-if="dataReady">
    <big-one :content="content" :type = "type" tuning="true" :a-page="true" :new-one="newOne"></big-one>
  </div>
</template>
<script>

const userName = {header: "Пользователь", name: "user.name", show: true, noAction: true, contains: false};
const actionDate = {header: "Дата", name: "date", show: true, valueFilter: true, before: null, after: null, sort: true, direction: true, date: true, noAction: true};
const action = {header: "Совершённое действие", name: "message", show: true, contains: "", noAction: true, rows: true};
const usersSelector = {selector: true, title: "Пользователь", name: "user", selectorList: null, contains: "all"}

export default{
  data() {
    return {
      type: "logg",
      content: [userName, actionDate, action, usersSelector],
      newOne: null,
      dataReady: false
    }
  },
  methods: {
    addNewOne() {
      let object = {name: '', id: 0, contact:{}};
      this.newOne = ({object: object, id: object.id, view: 'row'});
    }
  },
  async mounted() {
    usersSelector.selectorList = await this.$repo.getSelector("users");
    this.dataReady = true;
  }
}
</script>
<style>
</style>
